export const conditionResolver = {
  HAS_NO_AGENT: ({ userDetails }) => ({
    show: userDetails?.deviceSimulationData,
    status: "warning",
  }),

  // API_RESOLVERS
  SCAN_SCHEDULE_STATUS: (response) => {
    const nextFireTime = response?.[0]?.nextFireTime;

    if (nextFireTime) {
      // const formatted = new Date(nextFireTime).toLocaleString("default", {
      //   month: "long",
      //   day: "2-digit",
      //   year: "numeric",
      //   hour: "2-digit",
      //   minute: "2-digit",
      //   hour12: true,
      // });
      return {
        show: true,
        status: "info",
        response: {
          message: `Next scheduled scan will be executed on ${nextFireTime}`,
          linkMessage: "Configure",
        },
      };
    }

    return {
      show: true,
      status: "warning",
      response: {
        message:
          "You haven't configured the device scan schedule yet, please configure here",
        linkMessage: "Configure Schedule",
      },
    };
  },
  LOCATION_SETTINGS: (response) => {
    const message = String(
      response?.body?.message ?? response?.message ?? "",
    ).trim();
    const isDisabled = message
      .toLowerCase()
      .includes("geolocation tracking is disabled");

    return {
      show: isDisabled,
      status: "warning",
      response: {
        message:
          "You haven't configured the device location yet, please configure here",
        linkMessage: "Enable Device Location",
      },
    };
  },

  PATCH_SCAN_SUMMARY: (response) => {
    const data = response ?? {};
    const summary = {
      success: Number(data.success_count) || 0,
      inProgress: Number(data.in_progress_count) || 0,
      failed: Number(data.failed_count) || 0,
      timedOut: Number(data.timed_out_count) || 0,
    };

    const totalDevices =
      summary.success + summary.inProgress + summary.failed + summary.timedOut;

    return {
      show: totalDevices > 0,
      response: summary,
    };
  },
};
